import { render, staticRenderFns } from "./AddNewVenueForm.vue?vue&type=template&id=583b8405&"
import script from "./AddNewVenueForm.vue?vue&type=script&lang=ts&"
export * from "./AddNewVenueForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewVenueForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports